import {Directive, TemplateRef} from '@angular/core';

@Directive({
    selector: '[appTabContent]',
    standalone: false
})
export class TabContentDirective {

  constructor(public templateRef: TemplateRef<unknown>) {
  }

}
